// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_so-0";